import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Plus } from 'react-bootstrap-icons';
import FilterRow from './FilterRow';
import { ReportFieldMetadata, ReportFilter } from '../../types/report.types';

interface Props {
  filters: ReportFilter[];
  fields: ReportFieldMetadata[];
  onFiltersChange: (filters: ReportFilter[]) => void;
}

// Simple unique ID generator
const generateId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

function FilterBuilder({ filters, fields, onFiltersChange }: Props) {
  const addFilter = () => {
    const newFilter: ReportFilter = {
      id: generateId(),
      field: '',
      operator: 'Equals',
      value: ''
    };
    onFiltersChange([...filters, newFilter]);
  };

  const updateFilter = (index: number, updatedFilter: ReportFilter) => {
    const newFilters = [...filters];
    newFilters[index] = updatedFilter;
    onFiltersChange(newFilters);
  };

  const removeFilter = (index: number) => {
    const newFilters = filters.filter((_, i) => i !== index);
    onFiltersChange(newFilters);
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <strong>Filters</strong>
        <span className="text-muted ms-2">(Optional - leave empty to export all records)</span>
      </Card.Header>
      <Card.Body>
        {filters.length === 0 ? (
          <p className="text-muted mb-3">
            No filters added. Click &quot;Add Filter&quot; to filter your export.
          </p>
        ) : (
          filters.map((filter, index) => (
            <FilterRow
              key={filter.id}
              filter={filter}
              fields={fields}
              onUpdate={(updated) => updateFilter(index, updated)}
              onRemove={() => removeFilter(index)}
            />
          ))
        )}
        <Button variant="outline-primary" size="sm" onClick={addFilter}>
          <Plus size={16} className="me-1" />
          Add Filter
        </Button>
      </Card.Body>
    </Card>
  );
}

export default FilterBuilder;
